import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../utils/OggettiUtili";
import TabelleMonitoraggio from "./TabelleMonitoraggio";
import {states} from '../Wizard/States/States';
import styles from "./InserimentoSegnalazioni.module.css";
import CheckBox from "../../components/checkbox/CheckBox";
import _ from "lodash";
import globals from "../../config/appconfig";
class StatoInvioPremal extends Component {
    widthBreakdown = globals.appWidthBreakdown;
    state = {
        filtri: {
            idSegnalazione: "",
            ulssSegnalazione: "",
            tipoData: "",
            dataDa: "",
            dataA: "",
            malattia: "",
        },
        statoInvio: ["MX00", "MX01", "MX11", "MX20", "MX21", "MX22", "MX23", "MX99", "ND00", "00", "01", "11", "20", "21", "22", "23", "99", "D00"],
        noScartiNoAnomalie: true,
        conScarti: true,
        nonConforme: true,
        nonElaborato: true,
        nonRiuscito: true,
        malattie: JSON.parse(sessionStorage.getItem("malattie"))
    }


    rowsFiltriStatoInvioPremal = [
        {
            idSegnalazione: {
                id: "idSegnalazione",
                text: "ID segnalazione",
                tipo: "input",
                field: "idSegnalazione",
                numeroCol: 1
            },
            malattia: {
                id: "malattia",
                text: "malattia",
                tipo: "autocomplete",
                field: "malattia",
                numeroCol: 2,
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione"
            }
        },
        {
            ulssSegnalazione: {
                id: "ulssSegnalazione",
                text: "ULSS segnalazione",
                tipo: "selectAutocomplete",
                field: "ulssSegnalazione",
                numeroCol: 1,
                suggestions: OggettiUtili.ulssMap
            }
        },
        {
            dataInvio: {
                id: "dataInvio",
                tipo: "radio",
                text: "Data di invio",
                field: "tipoData",
                value: "dataInvio",
                numeroCol: 1
            },
            timestampCompilazione: {
                id: "timestampCompilazione",
                tipo: "radio",
                text: "Data di compilazione",
                field: "tipoData",
                value: "timestampCompilazione",
                numeroCol: 2
            }
        },
        {
            dataDa: {
                id: "dataDa",
                text: "dataDa",
                tipo: "data",
                field: "dataDa",
                placeholder: "data da",
                numeroCol: 1
            },
            dataA: {
                id: "dataA",
                text: "dataA",
                tipo: "data",
                field: "dataA",
                placeholder: "data a",
                numeroCol: 2
            }
        }

    ]

    colsTabStatoInvioPremal = [
        {
            key: "idUpload",
            name: "ID Upload",
            sortDirection: "none",
        },
        {
            key: "idSegnalazione",
            name: "ID Segnalazione",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {
            key: "malattia",
            name: "Malattia",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: JSON.parse(sessionStorage.getItem("malattiePerCodice")),
            campo: "descrizione"
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.Home.ulssSegn",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.ulssMap,
            campo: "descrizione"
        },
        {
            key: "dataSegnalazione",
            name: "Data segnalazione",
            sortDirection: "none",
            tipo: "data"
        },
        {
            key: "timestampCompilazione",
            name: "Data compilazione",
            sortDirection: "none",
            tipo: "data"
        },
        {
            key: "dataInvio",
            name: "Data invio",
            sortDirection: "none",
            tipo: "data"
        },
        {
            key: "tipoInvio",
            name: "Tipo invio",
            sortDirection: "none",
        },
        {
            key: "statoInvio",
            name: "Stato invio",
            tipo: "dizionario",
            oggetto: OggettiUtili.CodiciRitornoPremal,
            campo: "descrizione"
        },
        {
            key: "fileScarti",
            name: "File degli scarti",
        },
        {
            key: "erroreValidazione",
            name: "Stato validazione",
            tipo: "tooltip"
        },
        {
            key: "cancellazioneDatabase",
            name: "Cancellazione"
        },
    ]

    sendFiltri(filtriInvio) {
        this.props.creaFiltri({filtri: filtriInvio})
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    constructor(props) {
        super(props);
        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.sendFiltri = this.sendFiltri.bind(this)
        this.riceviValoreCheckbox = this.riceviValoreCheckbox.bind(this)
        this.azzeraCheckbox = this.azzeraCheckbox.bind(this)
    }

    azzeraCheckbox() {
        let state = _.cloneDeep(this.state);
        state.statoInvio = ["MX00", "MX01", "MX11", "MX20", "MX21", "MX22", "MX23", "MX99", "ND00", "00", "01", "11", "20", "21", "22", "23", "99", "D00"];
        state.noScartiNoAnomalie = true;
        state.conScarti = true;
        state.nonConforme = true;
        state.nonElaborato = true;
        state.nonRiuscito = true;
        this.setState(state);
    }

    riceviValoreCheckbox(field, event) {
        let state = _.cloneDeep(this.state);
        state[field] = event.target.checked;

        // codici MX* da GAF SOAP, codici senza prefisso da GAF REST
        let statoInvio = [];
        if (state.noScartiNoAnomalie) {
            statoInvio.push("MX20", "20");
        }
        if (state.conScarti) {
            statoInvio.push("MX21", "MX22", "21", "22");
        }
        if (state.nonConforme) {
            statoInvio.push("MX99", "MX11", "99", "11");
        }
        if (state.nonElaborato) {
            statoInvio.push("MX00", "MX01", "MX23", "00", "01", "23");
        }
        if (state.nonRiuscito) {
            statoInvio.push("ND00", "D00");
        }
        state.statoInvio = statoInvio;

        this.setState(state);
    }

    render() {
        const {t} = this.props;

        return (
            <div className={"row"}>
                <div className="col-2" style={{paddingTop: '100px', paddingLeft: '50px'}}>
                    <strong>Stato invio Premal:</strong>
                    <div className="row">
                        <CheckBox id="noScartiNoAnomalie"
                                  field="noScartiNoAnomalie"
                                  checked={this.state.noScartiNoAnomalie}
                                  text="Operazione completata senza scarti e senza anomalie"
                                  onChange={this.riceviValoreCheckbox}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"16px"}
                        />
                    </div>
                    <div className="row">
                        <CheckBox id="conScarti"
                                  field="conScarti"
                                  checked={this.state.conScarti}
                                  text="Operazione completata con scarti"
                                  onChange={this.riceviValoreCheckbox}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"16px"}
                        />
                    </div>
                    <div className="row">
                        <CheckBox id="nonConforme"
                                  field="nonConforme"
                                  checked={this.state.nonConforme}
                                  text="Upload non conforme"
                                  onChange={this.riceviValoreCheckbox}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"16px"}
                        />
                    </div>
                    <div className="row">
                        <CheckBox id="nonElaborato"
                                  field="nonElaborato"
                                  checked={this.state.nonElaborato}
                                  text="Upload non elaborato"
                                  onChange={this.riceviValoreCheckbox}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"16px"}
                        />
                    </div>
                    <div className="row">
                        <CheckBox id="nonRiuscito"
                                  field="nonRiuscito"
                                  checked={this.state.nonRiuscito}
                                  text="Invio non riuscito "
                                  onChange={this.riceviValoreCheckbox}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"16px"}
                        />
                    </div>
                </div>
                <div className={"col-10"}>
                    <div className={styles.contenitoreTabella}>
                        <TabelleMonitoraggio
                            cols={this.colsTabStatoInvioPremal}
                            title={"Stato invio Premal"}
                            emptyMsg={"Non ci sono segnalazioni"}
                            lengthEditable={false}
                            homePage={true}
                            rowFiltri={this.rowsFiltriStatoInvioPremal}
                            filtri={this.state.filtri}
                            sendFiltri={this.sendFiltri}
                            statoInvioPremal={"1"}
                            pageSize={globals["react_app_page_size"]}
                            statoInvio={this.state.statoInvio}
                            azzeraCheckbox={this.azzeraCheckbox}
                            setStateGenerico={this.setStateGenerico}
                        />
                    </div>
                </div>
            </div>
        )
    }


}

export default withTranslation('common')(StatoInvioPremal);